import React from 'react';
import { ForwardRef, typeOf } from 'react-is';
import ConfigProvider from './index';
export function withConfigProvider(Component) {
    const isClassComponent = (object) => !!Component?.prototype?.render;
    const isForwardRef = (object) => typeOf?.(object) === ForwardRef;
    let ComponentWithProvider = (props) => {
        return (React.createElement(ConfigProvider, { prefixCls: 'b-design' },
            React.createElement(Component, { ...props })));
    };
    if (isForwardRef(Component)) {
        // eslint-disable-next-line react/display-name
        ComponentWithProvider = React.forwardRef((props, ref) => {
            return (React.createElement(ConfigProvider, null,
                React.createElement(Component, { ...props, ref: ref })));
        });
    }
    else if (isClassComponent(Component)) {
        class ComponentWithProvider extends React.Component {
            render() {
                // @ts-ignore
                return React.createElement(Component, { ...this.props });
            }
        }
        const ownProperties = Object.getOwnPropertyNames(Component).filter((properyty) => !['$$typeof', 'render', 'displayName', 'prototype', 'arguments', 'caller'].includes(properyty));
        ownProperties.forEach((property) => {
            // ComponentWithProvider[property] = Component[property];
            Object.defineProperty(ComponentWithProvider, property, {
                value: Component[property],
                writable: true,
                configurable: true
            });
        });
        // @ts-ignore
        return ComponentWithProvider;
    }
    const ownProperties = Object.getOwnPropertyNames(Component).filter((properyty) => !['$$typeof', 'render', 'prototype', 'arguments', 'caller'].includes(properyty));
    ownProperties.forEach((property) => {
        // ComponentWithProvider[property] = Component[property];
        Object.defineProperty(ComponentWithProvider, property, {
            value: Component[property],
            writable: true,
            configurable: true
        });
    });
    // @ts-ignore
    return ComponentWithProvider;
}
